import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledMenuModalFooter = styled.div`
  .menu-footer {
    width: 86%;
    max-width: 86%;
    padding: 0;
    margin: auto;

    @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
      width: 74%;
      max-width: 74%;
    }
  

  &__list-container {
    max-height: 40vh;
    overflow: hidden auto;
    margin-bottom: ${toRem(16)};

    @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
      max-height: none;
      overflow: unset;
      margin-bottom: 0;
    }
  }

  &__show-more-button {
    background: none;
    color: ${baseVariables.color.base10};
  }

  &__diet-label {
    border: 1px solid #ff8d6b;
    box-sizing: border-box;
    border-radius: ${toRem(4)};
  }

  &__allergen-label {
    border: 1px dotted ${baseVariables.color.base10};
    box-sizing: border-box;
    border-radius: ${toRem(4)};
  }

  .t-label-s { 
    color: ${baseVariables.color.base10};
  }

  &__diet-list {
    border-right: none;
    column-gap: 10%;

    @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
      border-right: 1px solid ${baseVariables.color.neutral30};
      column-gap: 5%;
    }
  }

  &__allergen-list {
    column-gap: 10%;

    @media ${baseVariables.mediaQuery.lg}, @media ${baseVariables.mediaQuery.xl} {
      border-left: 1px solid ${baseVariables.color.neutral30};
      column-gap: 5%;
    }
  }
`;
